import {IItemUiEnv} from "/@back@/wsp/views/itemMain.js";
import {IReg, REG} from "/@lib@/commons/registry.js";
import {IView} from "/@lib@/commons/views.js";
import {JSX} from "/@lib@/commons/xml/dom.js";
import {JSrcFields, SRC} from "/@lib@/wsp/src.js";
import {ORemoteResRendererExtendedInit, RemoteResRendererExtended} from "/@back@/core/widgets/remoteResRenderer.js";
import {JRemoteResDescFromClient} from "/@lib@/core/remote.js";
import {Wsp, WSP} from "/@lib@/wsp/wsp.js";

/**
 * View d'une res remote avec la nouvelle approche JRemoteResDesc
 */
export interface RemoteResPreview extends RemoteResRendererExtended {
	initialize(init: ORemoteResPreviewInit): this;
}

export interface ORemoteResPreviewInit extends ORemoteResRendererExtendedInit {
	reg?: IReg<IItemUiEnv>
}

export class RemoteResPreview extends RemoteResRendererExtended implements IView {
	public reg: IReg<IItemUiEnv>

	private _wsp: Wsp;

	private _fields: JSrcFields;

	get wsp(): Wsp {return this._wsp || this.reg.env.wsp}

	set wsp(v: Wsp) {
		this._wsp = v;
		this._fields = null;
		this.refresh();
	}

	get fields(): JSrcFields {return this._fields || this.reg.env.longDesc}

	set fields(v: JSrcFields) {
		this._fields = v;
		this.refresh();
	}

	_initialize(init: ORemoteResPreviewInit) {
		init = Object.assign({
			fetchResDesc: () => {
				let transform = "transform=facet&facet=remoteContent&outType=RESDESC";
				return WSP.fetchStreamJson<JRemoteResDescFromClient>(this.wsp, null, SRC.srcRef(this.fields), transform) || {location: null, status: -1};
			},
		}, init);

		super._initialize(init);

		this.reg.env.longDescChange?.add((ldNew: JSrcFields) => this._refresh());
	}

}

REG.reg.registerSkin("wsp-remote-res-preview", 1, /* language=CSS */ `
	:host {
		overflow: auto;
		display: flex;
	}

	#title {
		color: var(--alt2-color);
	}
`);

customElements.define('wsp-remote-res-preview', RemoteResPreview);
